import React from 'react';
import { Modal, Form } from 'antd';
import { useModalProps } from '../../model/state';
import styles from './InvoiceModal.module.scss';

const Container = ({ form }) => {
  const { validateFields } = form;

  const {
    visible,
    afterClose,
    onCancel,
    Content,
    title,
    transform,
    loading,
    submitAsync,
    requestId,
    btnsDisabled,
  } = useModalProps();

  const handleSubmit = () => {
    validateFields(async (err, formValues) => {
      if (!err) {
        const values = transform(formValues);

        if (values) {
          await submitAsync({ requestId, ...values });
        }

        onCancel();
      }
    });
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      afterClose={afterClose}
      title={title}
      width={430}
      destroyOnClose
      confirmLoading={loading}
      okButtonProps={{ disabled: btnsDisabled }}
      cancelButtonProps={{ disabled: btnsDisabled }}
    >
      {Boolean(Content) ? (
        <Content
          form={form}
          className={styles.content}
        />
      ) : null}
    </Modal>
  );
};

const InvoiceModal = Form.create({
  name: 'invoice_modal',
})(Container);

export default InvoiceModal;
